import * as React from 'react'
import { createPortal } from 'react-dom'

export class PortalContentNavigation extends React.PureComponent<{ children?: React.ReactNode }> {
    public render() {
        const element = document.querySelector('[data-contentnavigation]')

        if (!element) {
            return this.props.children
        }

        return createPortal(this.props.children, element)
    }
}
